'use strict';
const angular = require('angular');
const ngAnimate = require('angular-animate');
const ngCookies = require('angular-cookies');
const ngResource = require('angular-resource');
const ngSanitize = require('angular-sanitize');


const ngRoute = require('angular-route');

import 'angular-validation-match';


import { routeConfig } from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import translator from '../components/i18n/translator';
import resources from '../components/resources';
import simpleCrud from '../components/simpleCrud';
import dailyReportComponent from '../components/dailyReport';
import shopPickerComponent from '../components/shopPicker';

import './app.scss';
import manager from './manager';
import assistants from './manager/assistants';
import dailyReport from './dailyReport';
import monthlyReport from './manager/monthlyReport';
import dailyReportReview from './manager/dailyReportReview';
import monthlySelling from './manager/monthlySelling';

angular.module('nomasvelloDashboardApp', [
  ngCookies,
  ngResource,
  ngSanitize,
  ngAnimate,

  ngRoute,

  resources,
  simpleCrud,
  dailyReportComponent,
  shopPickerComponent,
  _Auth,
  translator,
  account,
  admin,
  manager,
  assistants,
  dailyReport,
  dailyReportReview,
  monthlyReport,
  monthlySelling,
  'validation.match',
  navbar,
  footer,
  main,
  constants,
  util
])
  .config(routeConfig)
  .run(function ($rootScope, $location, Auth) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in
    $rootScope.$on('$stateChangeStart', function (event, next) {
      Auth.isLoggedIn(function (loggedIn) {
        if (next.authenticate && !loggedIn) {
          $location.path('/login');
        }
      });
    });
  });

angular
  .element(document)
  .ready(() => {
    angular.bootstrap(document, ['nomasvelloDashboardApp'], {
      strictDi: true
    });
    document.body.classList.remove('is-loading')
  });



// WEBPACK FOOTER //
// ./client/app/app.ts